import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import Header from "./header";
import MainCore from "./core";
import Footer from "./components/footer";
import intl from "react-intl-universal";
import "./mainStyle.css";
import "./app.css";
import InternalServerError from "./containers/InternalServerError";

// locale data
const locales = {
  "en-US": require("./locales/en-US.json"),
  // "zh-CN": require("./locales/zh-CN.js")
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initLocalizeDone: false,
      isLoggedIn: false,
      isLoading: true,
      firstName: "",
      lastName: "",
      email: "",
      customerId: "",
      hasServerError: false,
      showCookiesBanner: true,
      classNavBarName: "navbar navbar-expand-lg navbar-light",
      navLogo: "logo",
      isIEorEdge: false,
      pathname: "",
      showHeader: true,
      isSubLoginType: false,
      customerLogoUrl: "",
      sgsUrl: ""
    };
  }
  componentDidMount() {
    this.loadLocales();
    this.setState({ pathname: window.location.pathname });

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;
    this.setState({ isIEorEdge: isIE || isEdge });

    if (isIE || isEdge) return;

    // checking for a cookie in the url query - then, logging-in using this cookie
    var matchCookieInQuery = window.location.search.match(/[?&]cookie[=]([^&#]+)/i);

    if (matchCookieInQuery != null)
      this.loginWithCookie(matchCookieInQuery[1]); // logging-in with cookie and then continue with "checkLogin()"
    else
      this.checkLogin(); 
  }

  loginWithCookie(cookie) {
    fetch(process.env.REACT_APP_API_URL + "LoginWithCookie", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ Cookie: cookie }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result === "Success") {
          setTimeout(() => {
            this.checkLogin();
          }); 
        }
        else {
          this.setState({ isLoggedIn: false });
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        this.handleServerError(true);
        console.error(error);
      });
  }

  checkLogin() {
    fetch(process.env.REACT_APP_API_URL + "checklogin", {
      method: "POST",
      credentials: "include",
      Accept: "application/json",
      "Content-Type": "application/json",
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((result) => {
        var isSubLoginType = (result.SubLoginType == "EndpointWebGUI") ? true : false;
        if (result.Result === "Success") {
          this.setState({ isLoggedIn: true });
          this.setState({ firstName: result.FirstName });
          this.setState({ lastName: result.LastName });
          this.setState({ email: result.Username });
          this.setState({ customerId: result.CustomerId });
          this.setState({ isSubLoginType: isSubLoginType });
          this.setState({ sgsUrl: result.SGSUrl });
        } 
        else {
          this.setState({ isLoggedIn: false });
        }
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        this.handleServerError(true);
        console.error(error);
      });
  }

  loadLocales() {
    // init method will load CLDR locale data according to currentLocale
    // react-intl-universal is singleton, so you should init it only once in your app
    intl
      .init({
        currentLocale: "en-US", // TODO: determine locale here
        locales,
      })
      .then(() => {
        // After loading CLDR locale data, start to render
        this.setState({ initLocalizeDone: true });
      });
  }

  AddcookieConsentToCookies = () => {
    localStorage["cookiesAgreed"] = 1;
    this.setState({ showCookiesBanner: false });
  };

  userHasAuthenticated = (
    authenticated,
    firstName,
    lastName,
    username,
    customerId,
    isSubLoginType
  ) => {
    this.setState({ isLoggedIn: authenticated });
    if (authenticated) {
      this.setState({ firstName: firstName });
      this.setState({ lastName: lastName });
      this.setState({ email: username });
      this.setState({ customerId: customerId });
      this.setState({ isSubLoginType: isSubLoginType });
    } else {
      this.setState({ firstName: "" });
      this.setState({ lastName: "" });
      this.setState({ email: "" });
      this.setState({ isSubLoginType: false });
    }
  };

  handleServerError = (isError) => {
    this.setState({ hasServerError: isError });
  };

  handleLoginClick = () => {
    return <Route to="/account" props={this.state} />;
  };

  setHeaderClassName = (isTopFixed, isOnTop) => {
    if (isTopFixed) {
      if (isOnTop) {
        this.setState({
          classNavBarName:
            "navFixedHeader navbar navbar-expand-lg navbar-light fixed-top",
        });
        this.setState({ navLogo: "lightLogo" });
      } else {
        this.setState({
          classNavBarName:
            "navbar navbar-expand-lg navbar-light fixed-top",
        });
        this.setState({ navLogo: "logo" });
      }
    } else {
      this.setState({
        classNavBarName: "navbar navbar-expand-lg navbar-light",
      });
      this.setState({ navLogo: "logo" });
    }
  };

  handleUpdates = (params) => {     
    this.setState(params);
  }

  render() {
    if (this.state.isIEorEdge) {
      return (
        <div className="NotFound">
          <h3>
            This browser is not supported. Use one of the following browsers
            instead: Chrome, FireFox, Opera or Chromium Edge.
          </h3>
        </div>
      );
    }

    if (this.state.isLoading) {
      return (
        <div className="cssload-loader">
          <div className="cssload-square cssload-square--main">
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
            <div className="cssload-square cssload-square--mini" />
          </div>
        </div>
      );
      // return <div className="loader" />;
    }
    if (this.state.hasServerError) {
      return <InternalServerError />;
    }
    return (
      this.state.initLocalizeDone && (
        <div id="appMainDivId">
          {this.state.showCookiesBanner &&
          localStorage["cookiesAgreed"] === undefined ? (
            <div id="cookieConsent">
              <div
                id="closeCookieConsent"
                onClick={(e) => {
                  this.setState({ showCookiesBanner: false });
                }}
              >
                x
              </div>
              We use cookies to analyze traffic and provide you with better
              content. By continuing to use our site, you agree to the use of
              cookie technology.
              <a href="http://www.skylineglobe.com/SkylineGlobe/corporate/Legal/Terms.aspx">
                Read more
              </a>
              .
              <a
                className="cookieConsentOK"
                onClick={this.AddcookieConsentToCookies}
              >
                I agree
              </a>
            </div>
          ) : null}
          {this.state.showHeader ? 
          <Header
            classNavBarName={this.state.classNavBarName}
            navLogo={this.state.navLogo}
            isLoggedIn={this.state.isLoggedIn}
            userHasAuthenticated={this.userHasAuthenticated}
            handleServerError={this.handleServerError}
            onClick={this.handleLoginClick}
            firstName={this.state.firstName}
            lastName={this.state.lastName}
            userName={this.state.email}
            pathname={this.state.pathname}
            props={this.props}
            customerLogoUrl={this.state.customerLogoUrl}
            isSubLoginType={this.state.isSubLoginType}
          />
          : null}
          <div className="main-body">
          <MainCore
            isLoggedIn={this.state.isLoggedIn}
            setHeaderClassName={this.setHeaderClassName}
            userHasAuthenticated={this.userHasAuthenticated}
            firstName={this.state.firstName}
            lastName={this.state.lastName}
            email={this.state.email}
            customerId={this.state.customerId}
            handleServerError={this.handleServerError}
            handleUpdates={this.handleUpdates}
            isSubLoginType={this.state.isSubLoginType}
            customerLogoUrl={this.state.customerLogoUrl}
            sgsUrl={this.state.sgsUrl}
          />
          </div>
          {this.state.isSubLoginType ? 
          null
          : 
          <Footer />
          }
        </div>
      )
    );
  }
}

export default withRouter(App);
